import AuthClient from "../../api/AuthClient";
import { GroupStatusColor } from "../../api/enums/GroupInvitationStatus";
import { routes } from "../../routes/routes";
import { PromotersOffer } from "../../types";
import { getLoggedInUserId } from "../../utils/authUser";
import PromoterGroupClubRows from "./PromoterGroupClubRows";
import { useNavigate } from "react-router-dom";

interface PromoterSentOffersListProps {
  city: string;
  groupId: string;
  promotersOffers: PromotersOffer[];
}

const PromoterSentOffersList: React.FC<PromoterSentOffersListProps> = ({
  city,
  groupId,
  promotersOffers,
}) => {
  const navigate = useNavigate();
  const loggedInPromoterId = getLoggedInUserId(
    new AuthClient().getAuthenticationResponse()
  );
  const ownPromoterOffers = loggedInPromoterId
    ? promotersOffers.filter(
        (promoterOffer) => promoterOffer.promoter?.id === loggedInPromoterId
      )
    : [];
  const offers = ownPromoterOffers
    .flatMap((promoterOffer) => promoterOffer.offers)
    .sort((leftOffer, rightOffer) => Number(rightOffer.isAccepted) - Number(leftOffer.isAccepted));

  if (offers.length === 0) {
    return null;
  }

  return (
    <div className="promoter-group-detail__offers">
      <h3 className="promoter-group-detail__section-title">YOUR OFFERS ALREADY SENT</h3>
      <PromoterGroupClubRows
        city={city}
        clubs={offers.map((offer) => ({
          clubName: offer.clubName,
          offerType: offer.offerType,
          status: offer.isAccepted ? "Accepted" : undefined,
          statusColor: offer.isAccepted ? GroupStatusColor.Green : undefined,
          onClick: () => navigate(routes.PromoterOfferDetails(city, groupId, offer.id)),
        }))}
      />
    </div>
  );
};

export default PromoterSentOffersList;
